import { useEffect, useMemo } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux';
import LocalizedStrings from 'react-localization';
import LOCALIZATIONS from './localizations';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import './style.css';
import { NEW, RESIZE } from '../../redux/actions/board';
import { MODAL_TOGGLE } from '../../redux/actions/app';
import { useSnackbar } from 'notistack';
import { ID } from './config';

const NewBoard = () => {

    const dispatch = useDispatch(),
    { enqueueSnackbar } = useSnackbar(),
    labels = useMemo( () => new LocalizedStrings( LOCALIZATIONS ), []),
    { locale, modal } = useSelector( state => state.app ),
    open = Boolean( modal === ID );

    /**
     * @name commit
     * @function
     * @description Creates a new board
     */
    const commit = () => {
        dispatch({ type: NEW });
        dispatch({ type: RESIZE });
        enqueueSnackbar(
            labels.success,
            { variant: 'info' }
        );
        cancel();
    }

    /**
     * @name cancel
     * @function
     * @description Hides the modal
     */
    const cancel = () => {
        dispatch({ type: MODAL_TOGGLE });
    }

    // update locale
    useEffect(() => {
        if( locale !== labels.getLanguage() ) labels.setLanguage( locale )
    }, [ labels, locale ]);

    return (
        <Dialog open={ open } onClose={ cancel }>
            <DialogTitle>
                { labels.warning }  
            </DialogTitle>
            <DialogContent>
                <Typography>{ labels.instructions }</Typography>
            </DialogContent>
            <DialogActions>
                <Button aria-label={ labels.continue } onClick={ commit } variant="contained" startIcon={ <CheckCircleOutlineIcon /> }>
                    { labels.continue }
                </Button>
                <Button aria-label={ labels.cancel } variant="outlined" onClick={ cancel } startIcon={ <ArrowForwardIcon /> }>
                    { labels.cancel }
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default NewBoard;